import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import aaa from "./assets/util/md5";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// elementUI 国际化
import locale from "element-ui/lib/locale/lang/en";
Vue.use(ElementUI, { locale });

import axios from "axios";
Vue.prototype.$http = axios;
axios.defaults.headers.post["key"] = aaa.key;
axios.defaults.headers.post["salt"] = aaa.salt;
axios.defaults.headers.post["content-type"] =
  "application/x-www-form-urlencoded";

console.log(store.state.logInStatus);

// MD5加密
import md5 from "js-md5";
Vue.prototype.$md5 = md5;

// reset.css iconfont
import "./assets/styles/reset.css";
import "./assets/styles/iconfont/iconfont.css";
import "./assets/styles/iconfont/iconfont.js";

// animate 库
import animate from "animate.css";
Vue.use(animate);

import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

Vue.use(VideoPlayer);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  next();
});

import i18n from "./i18n";

document.oncontextmenu = new Function("return false");

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
